import { render, staticRenderFns } from "./ApprovedVacation.vue?vue&type=template&id=a2c2f242&"
import script from "./ApprovedVacation.vue?vue&type=script&lang=js&"
export * from "./ApprovedVacation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports